import { useEffect } from "react";
import useIdleTimer from "../hooks/useIdleTimer";
import { IdleProvider } from "./IdleContext";
import { connect } from "react-redux";
import AuthActions from "../stores/auth/Actions";
import { MINUTOS_INACTIVIDAD } from "../utils/Constant";
import AuthService from "../services/auth/AuthService";

const IdleTimerProvider = (props) => {
  const isLoggedIn = props?.authUserData?.isAuth;

  const LogOutPorInactividad = () => {
    if (isLoggedIn) {
      props.logoutUser();
      AuthService.notifyLogOutAllTabs();
    }
  };

  useIdleTimer(MINUTOS_INACTIVIDAD * 60 * 1000, LogOutPorInactividad);

  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === "cerrar_sesion") {
        props.logoutUser();
      }
    };

    window.addEventListener("storage", handleStorageEvent);

    return () => {
      window.removeEventListener("storage", handleStorageEvent);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <IdleProvider value={{}}>{props?.children}</IdleProvider>;
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {
  logoutUser: AuthActions.logoutUser,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(IdleTimerProvider);
